import React from "react";
import "./gallery.css";

const Gallery = () => {
  const images = [
    `${process.env.PUBLIC_URL}/images/photo1.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo2.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo3.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo4.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo5.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo6.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo7.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo8.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo9.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo10.jpeg`,
    `${process.env.PUBLIC_URL}/images/photo11.jpeg`,
  ];

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">📸 Photo Gallery</h2>

      <div className="gallery-grid">
        {images.map((src, index) => (
          <div className="gallery-card" key={index}>
            <img
              src={src}
              alt={`Gallery Photo ${index + 1}`}
              className="gallery-img"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
